import { z } from 'zod'
import { isAfter, set } from 'date-fns'

import { OFFICIAL_REPORT_FORM_FIELDS } from '../constant'
import { FormValuesType } from '../schema'

export const validateTakeoverTime = ({ data, ctx }: { data: FormValuesType; ctx: z.RefinementCtx }): void => {
    const actualTakeoverTime = data[OFFICIAL_REPORT_FORM_FIELDS.actualTakeoverTime]
    const takeoverTime = data[OFFICIAL_REPORT_FORM_FIELDS.takeoverTime]

    if (!actualTakeoverTime || !takeoverTime) {
        return
    }

    const [actualHour, actualMinute] = actualTakeoverTime.split(':').map(Number)
    const [hour, minute] = takeoverTime.split(':').map(Number)

    const now = new Date()
    const actualDate = set(now, { hours: actualHour, minutes: actualMinute, seconds: 0, milliseconds: 0 })
    const takeoverDate = set(now, { hours: hour, minutes: minute, seconds: 0, milliseconds: 0 })

    if (!isAfter(actualDate, takeoverDate)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Actual time must be later than the scheduled/given time.',
            path: [OFFICIAL_REPORT_FORM_FIELDS.actualTakeoverTime],
        })
        return
    }
}
